import {
  BANKING_ACCOUNT_NEEDS_UPDATING,
  BANKING_ACCOUNT_UPDATE_FAILED,
  BILLING_API_ERROR,
} from "../utils/constants";
import PropTypes from "prop-types";

const BankingAlert = ({ alertType }) => {
  return (
    <div
      id="banking-alert"
      data-testid="banking-alert"
      className="alert notice-bar"
    >
      <div className="alert--high-importance">
        <span className="icon-alert"></span>
        <ul className="alert-list">
          <li className="alert-content">
            {alertType === BANKING_ACCOUNT_UPDATE_FAILED && (
              <>
                <h4>Can't Verify Bank Account</h4>
                <p>
                  The bank account information you entered could not be
                  verified. Please double check the information or try a
                  different account. If you need help, you can contact our help
                  desk at 1-800-624-2513.
                </p>
              </>
            )}
            {alertType === BANKING_ACCOUNT_NEEDS_UPDATING && (
              <p>
                We are unable to process your payout to the bank account we have
                on file for you. To resolve, please update your banking details
                to continue using the Rewards platform.
              </p>
            )}
            {alertType === BILLING_API_ERROR && (
              <p>
                We are unable to add your Rewards banking information. To
                resolve, please confirm your entered banking information is
                correct. If you continue to experience issues, contact our help
                desk at 1-800-624-2513 for further assistance.
              </p>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

BankingAlert.propTypes = {
  alertType: PropTypes.oneOf([
    BANKING_ACCOUNT_UPDATE_FAILED,
    BANKING_ACCOUNT_NEEDS_UPDATING,
    BILLING_API_ERROR,
  ]).isRequired,
};

export default BankingAlert;
